/**
 * @generated SignedSource<<d192300b683e278458258c75fe6609fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageHeaderFragment$data = {
  readonly account: {
    readonly nouns: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"NounImageFragment">;
    }>;
    readonly tokenBalance: any;
  } | null;
  readonly " $fragmentType": "PageHeaderFragment";
};
export type PageHeaderFragment$key = {
  readonly " $data"?: PageHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageHeaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PageHeaderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tokenBalance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Noun",
          "kind": "LinkedField",
          "name": "nouns",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NounImageFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Address",
  "abstractKey": null
};

(node as any).hash = "b9a5cb43ba495a772489a5dc26adc430";

export default node;
